<template>
  <div class="authWrapper new-login-wrapper">
    <div class="container">
      <div class="row login-white-wrap register-margin whiteBG-wrap">
        <div class="col-lg-7 col-md-7 no-padding">
          <div class="login-left-wrap">
            <h6 class="login-highlight ">
              <router-link to="/" class="text-link">Back</router-link>
            </h6>
            <div class="rep-icon-login">
              <img src="../../assets/images/member-login.svg" alt="Member Login" />
            </div>
            <h4 class="login-title mb-2">Register to Member Dashboard</h4>
            <p class="sub-head">
              Register now to access valuable information organized for your convenience!
            </p>
            <div class="auth-form pt-1 pb-3">
              <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                <form @submit.stop.prevent="handleSubmit(verifyMember)">
                  <input-form-text
                  :customMessages="`Please enter lastname`"
                    :rules="{ required: true }"
                    labelFor="lastname"
                    labelName="Last Name"
                    inputName="lastname"
                    formGroupClass="form-group mb-3"
                    placeholder="Enter Last Name"
                    @emitChanges="resetErrorMsg"
                    :vmodel.sync="lastname"
                    :isErrorFlagSet="lastnameErrorFlag"
                  />
                  <div class="valid-error" v-if="lastnameErrorFlag">
                    {{ formErrors.lastname }}
                  </div>

                  <input-form-text
                   :customMessages="`Please enter last 4 digits of SSN`"
                    :rules="{ required: true, min: 4, max: 4 }"
                    labelFor="cssn4"
                    labelName="Last 4 Digits of SSN"
                    inputName="cssn4"
                    formGroupClass="form-group mb-3"
                    placeholder=" 1234"
                    :vmodel.sync="cssn4"
                    :isErrorFlagSet="ssnErrorFlag"
                  />
                  <div class="valid-error" v-if="ssnErrorFlag">
                    {{ formErrors.cssn }}
                  </div>

                  <label>Date of Birth<span class="required-label"> *</span></label>
                  <div class="row">
                    <div class="select-wrap col-lg-4 col-md-6">
                      <select v-model="selected_month" class="form-control mb-2">
                        <option value="" disabled>Month</option>
                        <option v-for="month in months" :key="month.value" :value="month.value">
                          {{ month.text }}
                        </option>
                      </select>
                    </div>
                    <div class="select-wrap col-lg-4 col-md-6">
                      <select v-model="selected_day" class="form-control mb-2">
                        <option value="" disabled>Day</option>
                        <option v-for="day in days" :key="day.value" :value="day.value">
                          {{ day.text }}
                        </option>
                      </select>
                    </div>
                    <div class="select-wrap col-lg-4 col-md-12">
                      <select v-model="selected_year" class="form-control mb-2">
                        <option value="" disabled>Year</option>
                        <option v-for="year in years" :key="year.value" :value="year.value">
                          {{ year.text }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="valid-error" v-if="formErrors.dob">
                    {{ formErrors.dob }}
                  </div>

                  <div class="valid-error" v-if="formErrors.error">
                    {{ formErrors.error }}
                  </div>

                  <button @click="verifyMember" :disabled="verifyLoader" class="btn submit-btn next-btn w-100 ml-0 mt-3">
                    <b-spinner v-if="verifyLoader" small></b-spinner>
                    Continue
                  </button>
                </form>
              </ValidationObserver>

            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-5 no-padding p-0">
          <LoginCarsoule />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/resource/MemberApi";
import helper from "../../resource/Helper";
import InputFormText from "../../components/form/InputFormText.vue";
import LoginCarsoule from "./Logincarsoule.vue";

export default {
  name: 'RegisterForm',
  components: {
    InputFormText,
    LoginCarsoule,
  },

  data() {
    return {
      lastname: '',
      cssn4: '',
      selected_month: '',
      selected_day: '',
      selected_year: '',
      months: [
        { text: "January", value: "01" },
        { text: "February", value: "02" },
        { text: "March", value: "03" },
        { text: "April", value: "04" },
        { text: "May", value: "05" },
        { text: "June", value: "06" },
        { text: "July", value: "07" },
        { text: "August", value: "08" },
        { text: "September", value: "09" },
        { text: "October", value: "10" },
        { text: "November", value: "11" },
        { text: "December", value: "12" },
      ],
      days: [
        { text: "01", value: "01" },
        { text: "02", value: "02" },
        { text: "03", value: "03" },
        { text: "04", value: "04" },
        { text: "05", value: "05" },
        { text: "06", value: "06" },
        { text: "07", value: "07" },
        { text: "08", value: "08" },
        { text: "09", value: "09" },
        { text: "10", value: "10" },
        { text: "11", value: "11" },
        { text: "12", value: "12" },
        { text: "13", value: "13" },
        { text: "14", value: "14" },
        { text: "15", value: "15" },
        { text: "16", value: "16" },
        { text: "17", value: "17" },
        { text: "18", value: "18" },
        { text: "19", value: "19" },
        { text: "20", value: "20" },
        { text: "21", value: "21" },
        { text: "22", value: "22" },
        { text: "23", value: "23" },
        { text: "24", value: "24" },
        { text: "25", value: "25" },
        { text: "26", value: "26" },
        { text: "27", value: "27" },
        { text: "28", value: "28" },
        { text: "29", value: "29" },
        { text: "30", value: "30" },
        { text: "31", value: "31" },
      ],
      years: [],
      formErrors:{},
      lastnameErrorFlag:false,
      ssnErrorFlag:false,
      verifyLoader: false,
    };
  },
  methods: {
    getYear() {
      let yearList = [];
      let year = new Date().getFullYear();
      for (let i = year - 100; i <= year; i++) {
        yearList.push({ text: i.toString(), value: i.toString() });
      }
      this.years = yearList;
    },
    verifyMember() {
      let [app, inputError] = [this, false];
      app.formErrorFlag = false;
      app.formErrors = [];
      let dob =
        app.selected_year + "-" + app.selected_month + "-" + app.selected_day;
      if (helper.validateDate(dob) == false) {
        inputError = true;
        app.formErrors["dob"] = "Please enter valid date of birth.";
        app.formErrorFlag = true;
      }
      if (!app.cssn4 || app.cssn4.toString().length != 4) {
        inputError = true;
        app.formErrorFlag = true;
      }
      if (!app.lastname) {
        inputError = true;
        app.formErrorFlag = true;
      }
      setTimeout(() => {
        app.formErrorFlag = false;
        app.formErrors = [];
      },5000);
      if (inputError) return;
      app.verifyLoader = true;

      Api
        .post("v2/auth/verify-member-signup", {
          cssn4: app.cssn4,
          last_name: app.lastname,
          dob: dob,
        })
        .then(function (response) {
          if (response.data.status == "success") {
            app.$store.commit("setMemberEmail", response.data.data.cemail);
            app.$store.commit("setMemberId", response.data.data.userid);
            app.$store.commit("setMemberPhone", response.data.data.phone1);
            helper.infoMessage(
              app,
              response.data.status,
              response.data.message
            );
            app.$router.push({
              name: "VerifyDetails",
            });
          }
        })
        .catch(function (error) {
          if (error.response.data.status == "error") {
            
            helper.infoMessage(
              app,
              error.response.data.status,
              error.response.data.message
            );
            app.formErrorFlag = true;
            app.formErrors["error"] = error.response.data.message;
            app.loginLoader = false;
            app.verifyLoader = false;
           
          }
        });
    },
    resetErrorMsg() {
      this.formErrors = {};
      this.lastnameErrorFlag=false;
      this.ssnErrorFlag=false
    },
  },
  created() {
    this.getYear();
  },
};
</script>

<style scoped>
.select-wrap select {
  font-size: 14px;
}
.register-margin {
  margin-top: 7rem;
}
</style>